import axios from 'axios';
import {clarify} from "../utils/clear";

class StatisticsApi {
    constructor() {
        this.endpoint =  process.env.VUE_APP_BASE_API;
        // https://ga-dev-tools.appspot.com/query-explorer/#report-end
        this.gaUrl = process.env.VUE_APP_GA_API;
    }

    get(param) {
        const params = new URLSearchParams(clarify(param));
        // console.log(params);
        return axios.get(`${this.endpoint}/analytics`, {params}).then(response=>response.data);
    }

    getCredentials() {
        return axios.get(`${this.endpoint}/analytics/credentials`, {}).then(response=>response.data);
    }
    getFromGA(accessToken, viewId, startDate, endDate, size) {
    // &start-date=30daysAgo&end-date=yesterday
    //     '?ids=ga%3A235046896';
        size = size ? size : 50;
        return axios.get(`${this.gaUrl}?ids=ga%3A${viewId}&start-date=${startDate}&end-date=${endDate}&access_token=${accessToken}&metrics=ga%3Asessions%2Cga%3Apageviews&dimensions=ga%3ApagePath&sort=-ga%3Apageviews&max-results=${size}`, {}).then(response=>response.data);
    }

    simple() {
        return axios.get(`${this.endpoint}/analytics/simple/get`, {}).then(response => response.data);
    }

    getRecentlyUsers(type = 'realTime', range = 29) {
        return axios.get(`${this.endpoint}/analytics/app`, {
            params: {
                reportType: type,
                setDateTime: range,
            },
        });
    }
}

export default new StatisticsApi();
